<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
<div>
  <div class="pc" v-if="$store.state.sizeType=='pc'">
    <div class="top">
      <img src="../assets/pc/logo1.png" class="logo">
      <div :class="'right type'+$store.state.pageType">
        <div class="one" v-for="(item,index) in navs" :key="index">
          <Dropdown v-if="item.children">
            <span>
              {{item.name}}
              <Icon type="md-arrow-dropdown" />
            </span>
            <template #list>
              <DropdownMenu>
                <DropdownItem v-for="(item2,index2) in item.children" :key="index2"><span @click="goPage(item2)">{{item2.name}}</span></DropdownItem>
              </DropdownMenu>
            </template>
          </Dropdown>
          <div class="first" v-else @click="goPage(item)">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
  

  <div class="phone" v-if="$store.state.sizeType=='phone'">
    <div :class="'show show'+type" v-if="!showAll">
      <img @click="goPage({path: 'index'})" src="../assets/phone/logo.png" class="logo">
      <img @click="showAll=true" class="right" src="../assets/phone/right.png">
    </div>

    <div class="hide" v-else>
      <div class="ptop">
        <img @click="goPage({path: 'index'})" src="../assets/phone/logo.png" class="logo">
        <Icon @click.stop="showAll=false" type="md-close" />
      </div>
      <div :class="'one type'+$store.state.pageType" v-if="index!=0" v-for="(item,index) in navs" :key="index">
        <div v-if="!item.children" class="ptitle" @click="goPage(item)">
          <p class="bigt">{{item.name}}</p>
          <img class="jiantou" src="../assets/phone/jiantou.png">
        </div>
        <div v-else>
          <p class="bigt bigt2">{{item.name}}</p>
          <div class="ptitle ptitle2" v-for="(item2,index2) in item.children" :key="index2" @click="goPage(item2)">
            <p class="smallt">{{item2.name}}</p>
            <img class="jiantou" src="../assets/phone/jiantou.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'top',
  inject: ['reload'],
  data() {
    return {
      navs: [],// 导航栏
      showAll: false,// 是否展示手机端顶部全部内容
    };
  },
  methods: {
    // 进入其他页面
    goPage: function(item){
      this.$router.push({path: `/${item.path}`});
    },
  },
  mounted() {
    this.navs = this.$language[this.$store.state.pageType].top.navs;
  }
};
</script>

<style scoped lang='scss'>
  .top{
    width: 100%;
    height: 64px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    padding: 0 calc(50% - 600px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 99999;
    border-bottom: 1px solid #EDEDED;
    color: #000000;

    .logo{
      width: 166px;
      height: 22px;
      flex-shrink: 0;
    }

    .right{
      height: 100%;
      display: flex;
      font-size: 18px;
      align-items: center;

      &.type2{
        width: 600px;
      }

      .one{
        cursor: pointer;
        height: 100%;
        line-height: 64px;
        margin-right: 50px;
        position: relative;

        .erji{
          width: 100%;
          // display: none;
          position: absolute;
          top: 64px;
          left: 0;
          background-color: #fff;
          font-size: 16px;

          p{
            margin-right: 20px;
            line-height: 30px;
          }
        }

        &:hover{
          border-bottom: 2px solid #000;

          .erji{
            display: block;
          }
        }
      }

      .yuyan{
        height: 26px;
        border-color: #333333;
        color: #333333;
      }
    }

    .searchMain{
      width: 100%;
      height: 126px;
      background-color: rgba($color: #262626, $alpha: 0.95);
      padding: 10px calc(50% - 600px) 37px calc(50% - 600px);
      position: fixed;
      top: 74px;
      left: 0;

      .main{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #585858;
        font-size: 22px;
        color: #fff;

        i{
          cursor: pointer;
        }

        input{
          text-align: center;
          font-size: 24px;
          color: #616161;
          background: none;
          border: none;
        }
      }
    }
  }

  .phone{
    
    .show{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      z-index: 9999;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.4rem;
      background-color: #fff;

      .logo{
        width: 1.8rem;
        height: 0.61rem;
      }

      .right{
        width: 0.32rem;
        height: 0.28rem;
      }

      &.show1{
        background-color: rgba($color: #ffffff, $alpha: 0);

        .right{
          color: #fff;

          .yuyan{
            border-color: #fff;
            color: #fff;
          }
        }
      }
    }

    .hide{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;
      background-color: #fff;
      color: #333333;
      padding: 0.4rem;
      overflow-y: scroll;

      .ptop{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.5rem;
        margin-bottom: 0.4rem;

        .logo{
          width: 1.8rem;
          height: 0.61rem;
        }
      }

      .one{
        padding: 0.3rem 0;
        border-top: 0.01rem solid #F5F5F5;
        border-bottom: 0.01rem solid #F5F5F5;

        .bigt{
          font-size: 0.36rem;
          font-weight: 400;
          color: #333333;
        }

        .bigt2{
          margin-bottom: 0.2rem;
        }

        .smallt{
          font-size: 0.24rem;
          color: #666666;
        }

        .ptitle{
          display: flex;
          align-items: center;
          justify-content: space-between;

          img{
            width: 0.24rem;
            height: 0.24rem;
          }
        }

        .ptitle2{
          height: 0.60rem;
        }

        .erji{
          margin-top: 0.25rem;
          display: flex;
          align-items: center;

          p{
            display: flex;
            align-items: center;
            font-size: 0.26rem;
            color: rgba($color: #ffffff, $alpha: 0.6);

            img{
              width: 0.02rem;
              height: 0.28rem;
              margin: 0 0.3rem;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue